import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUserCapabilities } from "@/hooks/useUserCapabilities";

/** Capability-based: allow if is_owner OR is_cohost. Cleaner-only → /worker/schedule. */
interface CalendarGuardProps {
  children: ReactNode;
}

export default function CalendarGuard({ children }: CalendarGuardProps) {
  const { user, profile, loading } = useAuth();
  const { is_owner, is_cohost, is_cleaner, isLoading: capsLoading } = useUserCapabilities();
  const navigate = useNavigate();

  const canAccess = is_owner || is_cohost;

  useEffect(() => {
    if (loading || capsLoading) return;
    if (!user) {
      navigate("/login");
      return;
    }
    if (!canAccess && is_cleaner) {
      navigate("/worker/schedule", { replace: true });
      return;
    }
    if (!canAccess) {
      navigate("/", { replace: true });
      return;
    }
  }, [user, profile, loading, capsLoading, canAccess, is_cleaner, navigate]);

  if (loading || capsLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p>Loading...</p>
      </div>
    );
  }

  if (!user || !canAccess) return null;

  return <>{children}</>;
}
